import axios from "axios";

const getCompanyProfile = (cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/company`)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_COMPANY_PROFILE",
          payload: response.data.data,
        });
        if (cb) {
          cb()
        }
      }
    }
  };
};

const createCompanyProfile = (cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const profile = store().companyProfile.profile;
    const form = new FormData();
    form.set("brandName", profile.brandName || "");
    form.set("companyName", profile.companyName || "");
    form.set("contactPersonName", profile.contactPersonName || "");
    form.set("address", profile.address || "");
    if (profile.logo) {
      form.set("logo", profile.logo);
    }

    const response = await axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/company`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_COMPANY_PROFILE",
          payload: response.data.data,
        });
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const updateCompanyProfile = (cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const profile = store().companyProfile.profile;
    const form = new FormData();
    form.set("companyName", profile.companyName || "");
    form.set("contactPersonName", profile.contactPersonName || "");
    form.set("address", profile.address);
    if (typeof profile.logo != "string") {
      form.set("logo", profile.logo);
    }

    const response = await axios
      .put(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/company`, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_COMPANY_PROFILE",
          payload: response.data.data,
        });
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const getCompanyDetails = (brand_slug, campaignID, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });

    const response = await axios
      .get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/brand/${brand_slug}/campaign/${campaignID}`
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      if (!response.data.success) {
        dispatch({
          type: "TOGGLE_LOADING",
        });
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
        if (cb) {
          cb(response.data.message)
        }
      } else {
        dispatch({
          type: "TOGGLE_LOADING",
        });
        dispatch({
          type: "GET_CAMPAIGN_DETAILS",
          payload: response.data.data,
        });
      }
    }
  };
};

const updateCompanyProfileInfo = (payload) => {
  return {
    type: "UPDATE_COMPANY_PROFILE_INFO",
    payload,
  };
};

const getCampaignInfo = (id) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/campaign/${id}`)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_CAMPAIGN",
          payload: response.data.data,
        });
      }
    }
  };
};
const postCampaignsDetails = (payload) => {
  let data = JSON.stringify(payload);
  return async (dispatch, store) => {
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .put(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/reward/claim`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_CAMPAIGN",
          payload: response.data.message,
        });
      }
    }
  };
};

export default {
  getCompanyProfile,
  updateCompanyProfileInfo,
  createCompanyProfile,
  updateCompanyProfile,
  getCompanyDetails,
  getCampaignInfo,
  postCampaignsDetails,
};
